import { render, staticRenderFns } from "./BasicTime.vue?vue&type=template&id=0d63d210"
import script from "./BasicTime.vue?vue&type=script&lang=js"
export * from "./BasicTime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports